export const TERMS_OF_SERVICE_HTML = `<p style="margin-bottom:1px;"><strong style="font-weight:500;font-size:14px;">TrueTenant Inc. &ndash; Terms of Service</strong></p>
<p style="margin-bottom:1px;"><strong style="font-weight:500;font-size:14px;">Effective Date:</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> June 24, 2026</span></p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">Last Updated:</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> June 24, 2026</span></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >The TrueTenant Inc. Terms of Service, including all sections below, (hereinafter, collectively, the
        &ldquo;Agreement&rdquo;) constitute the entire agreement between You and TrueTenant Inc. regarding the access to
        and use of the </span
    ><span style="font-weight: 300;font-size:14px;"
        >TrueTenant Platform, including our website, mobile application, Application Programming Interfaces (APIs), and
        any screening, marketplace, leasing, or payment-related services offered through it. This Agreement also applies
        to the ordering, purchasing, and/or receiving of paid tenant-screening products, subscription plans, or other
        services we provide.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >You must accept the terms of this Agreement before you may register for, purchase, or use any Services offered
        by TrueTenant. By creating an account, submitting a screening request, purchasing a report, or accessing any
        portion of the Platform, you affirm that you have read, understood, and agree to be bound by the then-current
        version of this Agreement. It is your responsibility to review this Agreement periodically to ensure you are
        aware of any updates. Where required by law, TrueTenant will provide advance notice of material changes.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;">In this Agreement, </span><strong style="font-weight:500;font-size:14px;">&ldquo;TrueTenant Inc.&rdquo;</strong
    ><span style="font-weight: 300;font-size:14px;">, </span><strong style="font-weight:500;font-size:14px;">&ldquo;TrueTenant,&rdquo;</strong>
    <strong style="font-weight:500;font-size:14px;">&ldquo;we,&rdquo;</strong> <strong style="font-weight:500;font-size:14px;">&ldquo;us,&rdquo;</strong><span style="font-weight: 300;font-size:14px;"> or </span
    ><strong style="font-weight:500;font-size:14px;">&ldquo;our&rdquo;</strong
    ><span style="font-weight: 300;font-size:14px;">
        refers to TrueTenant Inc., an Ontario corporation with its principal office at 713 Indian Road, Mississauga,
        Ontario, Canada.</span
    ><strong style="font-weight:500;font-size:14px;">&ldquo;You&rdquo;</strong><span style="font-weight: 300;font-size:14px;"> or </span><strong style="font-weight:500;font-size:14px;">&ldquo;User&rdquo;</strong
    ><span style="font-weight: 300;font-size:14px;">
        refers to any individual or entity accessing or using the Platform, including tenants, landlords, property
        managers, real estate agents, or authorized organizational representatives. TrueTenant works with certain
        third-party service providers (&ldquo;Service Providers&rdquo;) to deliver identity verification, financial-data
        aggregation, rental-history retrieval, AI analysis, payment processing, and hosting functions necessary to
        operate the Platform.</span
    >
</p>
<ol>
    <li style="font-weight: 300;font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">General Website and User Terms </strong><strong style="font-weight:500;font-size:14px;">(TrueTenant Version)</strong>
    </li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >This section applies when You visit the TrueTenant website (&lsquo;Site&rsquo;), mobile application, APIs, or
        any associated pages, subpages, sections, microsites, or integrated services (collectively, the
        &ldquo;Platform&rdquo;).</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.1 Governing Law and Jurisdiction:</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Access to, and use of, the Platform are subject to all laws and regulations applicable in your province or
        territory of residence. Individuals residing in jurisdictions where access to or use of the Platform is illegal
        or prohibited are not permitted to use the Platform. It is your responsibility to determine whether you may
        legally use the Platform in compliance with applicable laws.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Certain content, products, services, listings, and/or features may not be offered, be applicable or available
        to You based on residency, age or other eligibility criteria or factors. Persons accessing the Platform are
        required to obtain information about and observe any relevant restrictions. If any term or condition in this
        Agreement is found to be unlawful, void, or for any reason unenforceable, then that provision shall be deemed to
        be severable from the rest of the terms and conditions and shall not affect the validity and enforceability of
        any remaining provisions of the Agreement. The terms, exclusions and conditions of the written contracts
        relating to content or products mentioned on this Site are not fully described on the Site. Their interpretation
        is governed by the terms and conditions of the written contract You enter with Us, and by any applicable laws
        and regulations. The Agreement is made and will be interpreted under Ontario law, and you submit to the
        exclusive jurisdiction of Ontario courts located in Toronto.&nbsp;</span
    >
</p>
<ol>
    <li style="font-weight: 300;font-size:14px;"><strong style="font-weight:500;font-size:14px;">1.2.No Guarantee of Availability</strong></li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >THE PLATFORM AND ALL SERVICES ARE PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS,
        WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Given the nature of online systems and third-party integrations (including banking APIs, identity-verification
        services, and payment processors), TrueTenant does not represent or warrant that the Platform or its features
        will be uninterrupted, error-free, secure, or free of viruses, malicious code, or other harmful
        components.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Although we use reasonable efforts to maintain functionality and uptime, you acknowledge that interruptions,
        delays, or technical issues may occur for various reasons, including external service provider outages. We are
        not liable for any such issues.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >You agree to promptly notify us of any system errors. In the event of a system failure that prevents a paid
        screening or service from being delivered, your sole and exclusive remedy is a refund of the applicable fee you
        paid for that specific service.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.3 Product Modification or Termination</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >TrueTenant may modify, suspend, or discontinue any feature, screening service, subscription tier, or portion of
        the Platform at any time, with or without notice. We may also cancel, suspend, or terminate this Agreement for
        any reason.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >If we discontinue a paid service that you have purchased but not yet received, you will receive a pro-rated
        refund. Notice of such changes may be provided by email, through your account dashboard, or directly on the
        Platform.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.4 Disclaimers and Limitation of Liability</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >TrueTenant does not control or independently verify all information provided by Users or by third-party data
        sources (including Flinks, TenCheck, Verrif, OpenRoom, or hosting partners). Screening outcomes, eligibility
        results, and the TrueTenant Score depend on the accuracy and completeness of the information submitted by
        applicants and third-party providers.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >We make no representations, warranties, or guarantees except those expressly stated in this Agreement. We
        specifically do not guarantee the predictive value, accuracy, or outcome of any screening report, TrueTenant
        Score, or rental application assessment. TrueTenant is not liable for any decisions made by landlords, property
        managers, or tenants using the Platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >To the fullest extent permitted by law, TrueTenant disclaims all liability arising from your access to or use
        of the Platform or Services. Under no circumstances will TrueTenant, its affiliates, officers, employees,
        licensors, or service providers be liable for any direct, indirect, incidental, consequential, special,
        exemplary, or punitive damages, including loss of revenue, rental income, property damage, or issues arising
        from taxes charged or remitted in connection with Services.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.5 Electronic Communications</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Unless otherwise noted, all products and services offered through the TrueTenant Platform are internet-based
        and require that you maintain:</span
    >
</p>
<ul>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;">an internet browser capable of supporting modern encryption standards,</span>
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;">an active email account and compatible email software,</span>
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >a computer or mobile device with a reliable connection to the internet, and</span
        >
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >sufficient storage capacity or a printer to save or print electronic records.</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >You understand and agree that this Agreement is entered into electronically, and that all notices, disclosures,
        agreements, screening results, consent forms, invoices, and other communications (&ldquo;Communications&rdquo;)
        will be provided to you electronically&mdash;either through this Agreement, your email, your TrueTenant account
        dashboard, or notices posted on the Platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;">By using the Platform, </span><strong style="font-weight:500;font-size:14px;">you expressly consent</strong
    ><span style="font-weight: 300;font-size:14px;">
        to receive Communications electronically and agree that electronic delivery satisfies any legal requirement that
        such Communications be provided in writing.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.6 Ownership and Intellectual Property</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >TrueTenant is the owner and/or authorized licensor of the Platform, its software, algorithms (including the
        TrueTenant Score), screening tools, design elements, documentation, text, graphics, databases, and all other
        content made available through the Platform (&ldquo;TrueTenant Content&rdquo;).</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Where you access the Platform on behalf of a business (such as a property-management company), your use is
        limited to internal business purposes related to rental screening, listing management, and other
        property-related functions. If you access the Platform as an individual consumer, your use is limited to
        personal purposes related to rental applications and tenant-screening services.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;">You acknowledge that </span
    ><strong style="font-weight:500;font-size:14px;">all intellectual property rights remain vested exclusively in TrueTenant and its licensors</strong
    ><span style="font-weight: 300;font-size:14px;"
        >, and you acquire no ownership interest in any portion of the Platform. You agree that you will not, except as
        expressly permitted in this Agreement, attempt to </span
    ><span style="font-weight: 300;font-size:14px;"
        >&nbsp;do, or omit to do, anything which is likely to prejudice TrueTenant&rsquo;s ownership (or its
        licensors&rsquo; ownership) of its intellectual property rights, including:&nbsp;</span
    >
</p>
<ul>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >access, copy, store, merge, aggregate, scrape, or compile Platform content;</span
        >
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >modify, adapt, decompile, disassemble, or reverse-engineer the Platform or any component;</span
        >
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >derive or attempt to derive the source code, algorithms, scoring logic, or system architecture;</span
        >
    </li>
    <li style="font-weight: 300;font-size:14px;"><span style="font-weight: 300;font-size:14px;">create derivative works from the Platform;</span></li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >sublicense, sell, distribute, or commercially exploit any part of the Platform or Services; or</span
        >
    </li>
    <li style="font-weight: 300;font-size:14px;">
        <span style="font-weight: 300;font-size:14px;"
            >circumvent, bypass, or interfere with security features, access controls, or rate-limiting
            systems.&nbsp;</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;">
    <span style="font-weight: 300;font-size:14px;"
        >Any violation of these restrictions may result in suspension or termination of your account and may expose you
        to legal liability.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.6.1. Property Listings and User-Generated Content&nbsp;</strong></p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.1. User Content Ownership: </strong
    ><span style="font-weight: 300;font-size:14px;"
        >Users retain ownership of any photos, descriptions, documents, messages, listing information, profile data, or
        other materials (&ldquo;User Content&rdquo;) that they upload, submit, or transmit through the Platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.2.</strong> <strong style="font-weight:500;font-size:14px;">License to TrueTenant:</strong
    ><span style="font-weight: 300;font-size:14px;">
        By uploading or submitting User Content, you grant TrueTenant a non-exclusive, worldwide, royalty-free,
        transferable licence to host, store, reproduce, display, distribute, and otherwise use such User Content as
        necessary to operate, maintain, market, and improve the Platform and related Services.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.3. Representations: </strong
    ><span style="font-weight: 300;font-size:14px;"
        >You represent and warrant that: (a) you have all necessary rights and permissions to upload and use the User
        Content; (b) the User Content is accurate, lawful, and not misleading; (c) the User Content does not infringe
        any intellectual property, privacy, or proprietary rights of any third party; and (d) the User Content complies
        with all applicable laws, including housing, privacy, and human-rights legislation.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.4. Property Listings:</strong
    ><span style="font-weight: 300;font-size:14px;">
        Landlords and Property Managers are solely responsible for ensuring the accuracy, legality, and completeness of
        all property listings, including photos, pricing, amenities, availability, and descriptions. TrueTenant does not
        verify or guarantee the accuracy, safety, condition, or suitability of any property.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.5. Right to Remove or Modify Content:</strong
    ><span style="font-weight: 300;font-size:14px;">
        TrueTenant may remove, disable access to, or request modification of any User Content that violates this
        Agreement, applicable law, or TrueTenant policies, or that TrueTenant determines, in its sole discretion, to be
        harmful, fraudulent, misleading, or inappropriate.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.1.6. No Liability for User Content:</strong
    ><span style="font-weight: 300;font-size:14px;">
        TrueTenant does not control, verify, or endorse User Content and is not responsible for any errors, omissions,
        inaccuracies, or resulting disputes between Users.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2. User Conduct</strong><span style="font-weight: 300;font-size:14px;"> - Users agree </span><strong style="font-weight:500;font-size:14px;">not</strong
    ><span style="font-weight: 300;font-size:14px;">
        to engage in any of the following conduct when accessing or using the Platform:</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.1. Harassment or Discrimination</strong
    ><span style="font-weight: 300;font-size:14px;"
        >: Engaging in abusive, threatening, hateful, discriminatory, or harassing behaviour toward any User, landlord,
        tenant, property manager, or TrueTenant representative.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.2. Uploading Harmful or Offensive Content</strong
    ><span style="font-weight: 300;font-size:14px;"
        >: Uploading, posting, or transmitting any content that is defamatory, obscene, hateful, violent, or otherwise
        inappropriate or disruptive to the Platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.3. Security Interference: </strong
    ><span style="font-weight: 300;font-size:14px;"
        >&nbsp;Attempting to damage, disrupt, or interfere with Platform operations, including: (a) uploading malware or
        harmful code, (b) attempting unauthorized access to accounts, systems, APIs, or data, or (c) bypassing security
        controls, authentication measures, or rate limits.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.4. Unauthorized Commercial Use</strong
    ><span style="font-weight: 300;font-size:14px;"
        >: Using the Platform or its Services to solicit, advertise, run promotions, or conduct unrelated commercial
        activity without TrueTenant&rsquo;s written approval.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.5. Improper Use of Other Users&rsquo; Information</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Accessing, collecting, storing, or using personal information of other Users (including tenants or landlords)
        for any purpose not expressly authorized by this Agreement or by the User whose information is involved.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">1.6.2.6. Interference With Property Listings or Marketplace Integrity</strong><strong style="font-weight:500;font-size:14px;"><br /></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Manipulating property listings, reviews, communications, or application workflows in ways that mislead or harm
        other Users or undermine the integrity of the Platform.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.7 Security, Cookies, and Links</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Once You have gained access to the TrueTenant Site, it is highly recommended that You do not leave the computer
        terminal until You have left the Site. We do not warrant that any information, software or other material
        accessible through the Site or through links to other websites are free of viruses, worms, Trojan horses or
        other harmful components. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Internet-based communication&mdash;including submission of documents, identity verification, and data
        transmission&mdash;may not be fully secure without encryption, and privacy cannot be absolutely guaranteed. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Without the use of encryption, communication through the Internet or electronic communication is not secure and
        privacy cannot be ensured. We do not review or approve outside sites that are or may be accessible through the
        platform. Links from or to Internet websites outside the Site are meant for convenience only and you access them
        at Your own risk.&nbsp;</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >These links should not be construed as an endorsement, a guarantee or a recommendation of the products or
        services offered on those sites. We expressly disclaim any liability of any nature whatsoever arising directly
        or indirectly from other sites connected to the Site by hyperlink or otherwise linked to TrueTenant&rsquo;s
        platform. Additional information about cookies, pixel tags, and other technology used on the Site can be found
        in our Privacy Policy.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">1.8 Waiver, Severability, and Assignment</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant&rsquo;s waiver of a breach of any provision of this Agreement will not operate or be interpreted as
        a waiver of any other or subsequent breach. If any part of this Agreement is held to be invalid or
        unenforceable, that part will be severed and the rest of the Agreement will remain in force. You may not
        transfer or assign any part of this Agreement. We may assign this Agreement without restriction.</span
    >
</p>
<ol start="2">
    <li><strong style="font-weight:500;font-size:14px;"> Specific Additional Terms for Screening, Verification, and Tenant-Facing Services</strong></li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">This section applies </span><strong style="font-weight:500;font-size:14px;">in addition to Section 1</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        when you create a TrueTenant account as a consumer and order or receive tenant-screening, identity-verification,
        rental-readiness, rental-application services or property listing services (collectively, &ldquo;Screening
        Services&rdquo;).</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.1 Tenant Screening Services:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"> TrueTenant is a technology provider.
        TrueTenant prepares and furnishes tenant-screening reports&mdash;including the TrueTenant Score&mdash;based on
        information you submit directly, information obtained through your authorized third-party data connections
        (e.g., Flinks, TenCheck, OpenRoom, Verrif), and information maintained in your TrueTenant tenant file. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant facilitates the delivery of screening reports, manages payments, and supports lease generation for
        landlords and property managers, and uses relevant collected information to produce Screening Services for your
        personal benefit and to furnish reports to landlords or property managers only with your explicit consent. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Our platform also enables tenants and landlords/ property managers to communicate, exchange documents, and
        complete rental transactions through secure workflows.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.1.1</strong>
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.1.2 </strong><span style="font-weight: 400;color:#32302F; font-size:14px;">TrueTenant is </span><strong style="font-weight:500;font-size:14px;">not</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        a real estate agent, property broker, lender, guarantor, insurer, or housing advisor, and does not own, manage,
        inspect, or control any property listed on the Platform. TrueTenant does not guarantee the condition,
        availability, or suitability of any property, nor the outcome of any tenant screening or rental decision.
        TrueTenant is </span
    ><strong style="font-weight:500;font-size:14px;">not a credit bureau</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        and does not maintain or furnish credit reports for lending or credit-granting purposes.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.1.3. </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Where Tenants list minors as occupants, they may only provide the minor&rsquo;s age and relationship (e.g.,
        child, sibling) and must not submit additional identifying data about the minor except as expressly required by
        TrueTenant and permitted by law.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">2.2 <strong style="font-weight:500;font-size:14px;">Registration and Use of Screening Services- </strong
    ></span><span style="font-weight: 400;color:#32302F; font-size:14px;">To access Screening Services, you must:</span>
</p>
<ol>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">complete the registration process and create a TrueTenant account;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">provide accurate, current, and complete information;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">be the individual whose information is being submitted;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">be at least eighteen (18) years old; and</span></li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">agree to abide by all terms governing the use of Screening Services.</span>
    </li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Some Screening Services&mdash;such as identity verification, tenant screening, or lease
        generation&mdash;require payment unless provided through a promotional or subsidized program.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You must create a unique username and maintain the confidentiality of your password. You may not share your
        account with any other person. Users are responsible for maintaining the confidentiality of their login
        credentials and for all activity conducted under their account.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">Screening Services are provided </span><strong style="font-weight:500;font-size:14px;">for your personal use</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, such as understanding your rental-readiness profile and authorizing disclosure of screening results to
        landlords or property managers.</span
    >
</p>
<p style="margin-bottom:15px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">By using any screening services offered by Us, you:</span></p>
<ul>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Users understand and agree that the final rental decision rests solely with the landlord or property
            manager, not TrueTenant.&nbsp;</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Users agree not to: use Screening Services to evaluate others for commercial purposes; resell or
            redistribute screening outputs, or; access Screening Services on behalf of a third party without lawful
            authority and consent.</span
        >
    </li>
</ul>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant reserves the right to suspend or terminate any account that provides false information, engages in
        fraudulent behaviour, or violates any Terms set out in this Agreement.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.4 Proprietary Nature of the TrueTenant Score</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">The TrueTenant Score is a </span
    ><strong style="font-weight:500;font-size:14px;">proprietary tenant-suitability model developed by TrueTenant</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        and based on applicant-authorized data such as income patterns, banking behaviour, rental history, identity
        verification, and verified employment information.Your Score may change whenever new information is added to or
        removed from your file, or whenever updated verification data becomes available.The TrueTenant Score is provided </span
    ><strong style="font-weight:500;font-size:14px;">solely to help landlords assess tenancy suitability</strong>
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >and to help tenants understand the factors that influence rental eligibility specifically.</span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant does not guarantee that a landlord or property manager will reach the same conclusion as the Score,
        and the Score does not replace individualized assessments or legal tenant-screening requirements under the
        Residential Tenancies Act.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.5 No Predictive Guarantee: </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant does not warrant the predictive value, accuracy, or outcome of any TrueTenant Score. The Score is an
        evaluative tool only and does not determine the final rental decision, which rests solely with the landlord or
        property manager.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.6 Membership and Payment Authorization: </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Certain TrueTenant Services&mdash; including tenant-screening reports, lease-generation tools, premium
        features, or subscription tiers&mdash;require that You establish a continuing membership or complete a one-time
        purchase through the Platform. The initial term associated with any paid Service will be clearly defined in the
        offer details presented at the time of enrolment or purchase. However, most subscriptions are effective
        for:&nbsp;</span
    >
</p>
<p style="margin-bottom:15px;">
    <em><span style="font-weight: 400;color:#32302F; font-size:14px;">2.6.1. *Types of subscriptions to be offered should be listed here*</span></em>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Once established, all recurring memberships automatically renew indefinitely without further action by You, and
        the applicable fee for any paid Service is automatically charged to Your designated payment method at the time
        of renewal, in accordance with the payment terms to which You agreed. TrueTenant reserves the right to increase
        or decrease fees associated with any paid Service from time to time with or without notice, and You agree that
        unless You cancel Your membership prior to the effective date of such change, You will be charged the updated
        fee.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.7 Fees, Charges, and Payment Source:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        By placing an order for a tenant-screening report, subscription, lease-generation Service, or any other paid
        feature, You authorize TrueTenant and its third-party payment processor (Stripe or such other processor as
        TrueTenant may designate) to charge Your credit card, debit card, or other payment method that You have provided
        (&ldquo;Payment Source&rdquo;) for all applicable fees, taxes, and charges in Canadian dollars. You further
        authorize TrueTenant to maintain Your membership or paid Services by automatically charging Your designated
        Payment Source for the then-current fees associated with your prescribed renewal term. If Your Payment Source
        expires, becomes invalid, or is otherwise unavailable, You authorize TrueTenant or its payment processor to
        attempt to update Your Payment Source automatically where supported by Your financial institution. If updated
        information is obtained, TrueTenant will charge the updated Payment Source. If TrueTenant is unable to charge or
        update Your Payment Source, Your access to paid Services may be suspended or terminated, with or without notice.
        TrueTenant is not responsible for overdraft fees, over-the-limit fees, or bank charges triggered by the
        processing of Your order.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Unless expressly stated otherwise at the time of purchase, all payments for tenant-screening reports,
        lease-generation tools, subscription Services, or other paid features are </span
    ><strong style="font-weight:500;font-size:14px;">non-refundable once the Service has been initiated</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, as TrueTenant incurs verification, processing, and data-retrieval costs immediately upon
        activation.&nbsp;</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >All fees displayed on the Platform are exclusive of applicable taxes. You agree to pay all sales taxes,
        harmonized sales taxes, or other applicable taxes assessed in connection with Your purchase of Services.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >All payments made through the Platform are processed securely by Stripe or other authorized payment processors.
        TrueTenant does not store full credit card or debit card numbers and relies on third-party processors to
        maintain Payment Source information in accordance with applicable security standards.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.7.1 Your Obligations: </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >&nbsp;You agree to keep Your Payment Source information accurate and up-to-date at all times and to promptly
        update Your account if Your billing address, card number, expiration date, or other relevant information
        changes. Failure to maintain accurate Payment Source information may result in suspension or termination of
        access to paid Services.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.7.2 Free Trials; Conversions to Paid Membership</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Whenever offered, all free trials of TrueTenant Services require that You enroll as a User with an active
        account on the Platform. EnrollmentEnrolment in a free trial obligates You to continue Your subscription beyond
        the expiration of the free trial period unless You take the steps required to cancel Your subscription before
        the trial period ends. You should carefully consider these obligations before enrolling in any free trial.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >As part of any free-trial enrolment, You must provide a valid payment method (&ldquo;Payment Source&rdquo;).
        Prior to activating Your free trial, a temporary authorization hold may be placed on the Payment Source to
        validate it. TrueTenant will not charge Your Payment Source until the free trial period has expired, provided
        that You have not cancelled Your trial membership before the end of the trial.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If You wish to continue Your membership after the trial period, You do not need to take any action. Your
        subscription will automatically continue without interruption, and the applicable subscription fee will be
        charged to the Payment Source provided at the time of enrolment.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You may cancel Your trial membership at any time during the free trial period without charge or further
        obligation by using the cancellation tools available in Your TrueTenant account settings. TrueTenant reserves
        the right to impose quantity limits on free trials of our Services and may refuse to register You for a free
        trial for any reason, including repeated trial enrollmentenrolment attempts.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.8. Cancellation and Refunds</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You may cancel any subscription-based TrueTenant Service at any time. These Services operate as automatically
        renewing subscriptions (&ldquo;continuity plans&rdquo;) and will continue indefinitely until You
        cancel.&nbsp;</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Cancellation must be completed through Your TrueTenant account settings. Once You submit a cancellation
        request, it becomes effective immediately. Upon cancellation, You will receive an on-screen confirmation and
        Your account dashboard will reflect the updated cancellation status. You will immediately lose access to
        subscription-based features, including premium landlord tools, advanced AI insights, tenant-screening credits,
        or any other paid Services.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.8.1. Free Trials</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >: If You cancel during the free trial period, Your access to the subscription-based features will end at the
        conclusion of the trial period and Your Payment Source will not be charged.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.8.2. Paid Subscriptions:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >&nbsp; You may be entitled to a pro-rated refund for any subscription fee paid for Services not yet provided at
        the time of cancellation, except where a screening, lease, or paid action has already been initiated. If a fee
        relates to a tenant-screening report or other one-time Service already delivered, no refund will be
        issued.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.8.3. No Restrictions on Early Cancellation:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        There are no terms preventing You from cancelling Your subscription before the current term expires.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.9 Service Changes: </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant may change the prices for any paid Services offered through the Platform&mdash;including
        tenant-screening reports, subscription tiers, landlord tools, and other paid features&mdash;at any time, with at
        least thirty (30) days&rsquo; written notice to You (the &ldquo;Notice Period&rdquo;). You will be charged the
        new price for all future purchases or renewals of paid Services at the end of the Notice Period. All fees
        displayed on the Platform exclude applicable sales taxes (&ldquo;Taxes&rdquo;), which will be added and payable
        by You at the time of purchase, where required by law.</span
    >
</p>
<p style="margin-bottom:15px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">&nbsp;</span></p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.10 Service Variations: </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant&rsquo;s paid Services do not all include the same features, benefits, or access levels. Prior to
        purchasing any screening report, subscription plan, or paid tool, You should review the description of each
        Service on the Platform to ensure it meets Your needs. Each Service description outlines the features included,
        usage limitations, and any associated fees.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If You have questions regarding TrueTenant&rsquo;s Services, You may contact Us using the support channels
        available through the Platform. If You are already a Subscriber, You may view a complete description of Your
        current plan&mdash;including screeningsincluding included screenings, landlord tools, AI insights, and usage
        instructions&mdash;by visiting Your account dashboard.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If You are already a Subscriber and later determine that another plan may be more suitable for Your needs,
        TrueTenant may allow You to upgrade, downgrade, or substitute Your existing subscription for another Service,
        subject to any applicable fee differences. Substitutions or upgrades may result in a higher subscription
        fee.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.12 Communications:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        You may request a paper copy of any legally required notice, withdraw your consent to receive Communications
        electronically, or update your email or postal address for receiving Communications by contacting the TrueTenant
        Support Team at </span
    ><strong style="font-weight:500;font-size:14px;">*</strong><strong style="font-weight:500;font-size:14px;"><em>enter support information here* </em></strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">or through the communication options provided in your TrueTenant account.</span>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If you withdraw consent to electronic Communications, certain Services may become unavailable, and TrueTenant
        may be required to provide legally mandated notices by mail in accordance with applicable legislation</span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">, including the Consumer Reporting Act (Ontario).</span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">&nbsp;</span>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >All formal legal notices under this Agreement shall be sent to legal@truetenant.ai or to any updated address
        specified on the Platform.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.13 Tenant-File Monitoring</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >When offered or included as part of our Services, &ldquo;Tenant-File Monitoring&rdquo; refers to
        TrueTenant&rsquo;s automated process that notifies you when new information is added to, removed from, or
        updated within your </span
    ><strong style="font-weight:500;font-size:14px;">TrueTenant consumer file</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, including information relevant to your Screening Report or TrueTenant Score.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >The Tenant-File Monitoring you request and authorize will monitor the file uniquely associated with you based
        on the identifying information you provide, such as your first and last name, date of birth, phone number,
        email, address history, and applicant-submitted identifiers.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">Tenant-File Monitoring will </span><strong style="font-weight:500;font-size:14px;">not</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >: (1) notify you of information appearing in another individual&rsquo;s tenant file; (2) compare or
        cross-reference your file with another person&rsquo;s file; or (3) provide you with access to any personal
        information belonging to another individual.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant will only monitor the file assigned to you and will never disclose or cross-reference tenant data
        across individuals.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.14 Identity Protection and Fraud-Monitoring Features</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Certain TrueTenant Services include features designed to assist you in detecting, preventing, and responding to
        unauthorized access, misuse, or tampering involving your TrueTenant profile, identity-verification materials, or
        tenant-screening data (&ldquo;Identity Protection Features&rdquo;). These features may include alerts for
        suspicious logins, notifications of changes to your TrueTenant file, enhanced biometric verification, and
        fraud-risk signals generated by our security systems.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">Identity Protection Features </span><strong style="font-weight:500;font-size:14px;">do not</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        include identity-theft restoration services, credit-monitoring services, or credit-identity insurance, and this
        Section does not apply to those products.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant offers several types of Identity Protection Features, and not all Services include the same
        benefits. Before enabling or purchasing any Service that includes Identity Protection Features, you should
        carefully review the applicable product description on the Platform to understand which features are included
        and what limitations may apply.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">Our Identity Protection Features are </span><strong style="font-weight:500;font-size:14px;">informational tools</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        that provide alerts or insights to help minimize the risk of unauthorized access to your TrueTenant account or
        screening file, and to help you respond in the event of a suspected incident involving the misuse of your
        personal information on the TrueTenant Platform.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >For the purposes of this Agreement, &ldquo;Identity Misuse&rdquo; means the unauthorized access, use,
        alteration, or submission of your personal information&mdash;including your name, email address, phone number,
        government-issued identification, or biometric identifiers&mdash;through the TrueTenant Platform without your
        knowledge or authorization.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >This Section provides only a summary of applicable Identity Protection Features. It does not contain an
        exhaustive list of terms, limitations, exclusions, or conditions associated with these features. Please review
        all applicable Service descriptions and Platform materials for full details before enabling or purchasing a
        feature.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;"
        >BY ACCESSING OR USING ANY IDENTITY PROTECTION FEATURE, YOU ACKNOWLEDGE AND AGREE THAT NO FEATURE OR SERVICE CAN
        PREVENT OR DETECT ALL FORMS OF IDENTITY MISUSE OR FRAUD. YOU AGREE TO TAKE REASONABLE PRECAUTIONS TO PROTECT
        YOUR LOGIN CREDENTIALS, DEVICES, AND PERSONAL INFORMATION, AND TO AVOID SHARING SUCH INFORMATION WITH ANY PERSON
        OR ENTITY THAT COULD BE REASONABLY EXPECTED TO MISUSE IT.</strong
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TRUETENANT INC., ITS DIRECTORS, OFFICERS, EMPLOYEES, AGENTS, SERVICE PROVIDERS, AND AFFILIATES </span
    ><strong style="font-weight:500;font-size:14px;">DISCLAIM ALL WARRANTIES</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, WHETHER EXPRESS OR IMPLIED, WITH RESPECT TO IDENTITY PROTECTION FEATURES, INCLUDING ANY WARRANTY THAT SUCH
        FEATURES WILL MEET YOUR NEEDS OR OPERATE WITHOUT INTERRUPTION OR ERROR. NO IDENTITY PROTECTION FEATURE PROVIDED
        BY TRUETENANT CONSTITUTES AN INSURANCE POLICY OR CONTRACT AGAINST IDENTITY MISUSE, FRAUD, OR THE CONSEQUENCES
        THEREOF. TRUETENANT&rsquo;S LIABILITY TO YOU FOR ANY SUCH INCIDENT IS STRICTLY LIMITED TO THE SPECIFIC FEATURES
        AND REMEDIES EXPRESSLY DESCRIBED IN THIS AGREEMENT.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >TrueTenant reserves the right to request corroborating evidence of any reported incident of Identity Misuse on
        the Platform, which may include a sworn statement, police report, identity-theft report, or other documentation.
        Failure to provide such corroboration may result in the refusal to provide certain Identity Protection Features
        or associated benefits.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If you cancel any Service or membership that includes Identity Protection Features, TrueTenant is no longer
        obligated to provide such features or benefits, regardless of whether a suspected or actual incident occurred
        while your membership was active.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">2.16 Personal Information</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >As necessary to provide Tenant-Screening Services, Marketplace-eligibility assessments, and other Platform
        features, You authorize and instruct TrueTenant and its Service Providers to collect, use, verify, analyze,
        compile, and disclose Your Personal Information (&ldquo;PII&rdquo;) strictly for the purposes described in this
        Agreement and in the TrueTenant Privacy Policy.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >By placing an order for any screening service, creating a User account, or submitting an application on the
        Platform, You acknowledge and agree that Your access to screening results, the TrueTenant Score, Marketplace
        eligibility, and any verification outputs is subject to Your </span
    ><strong style="font-weight:500;font-size:14px;">prior express consent</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"> and TrueTenant&rsquo;s approval of Your order.&nbsp;</span>
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">2.16.1 </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >By submitting Your information, You are providing &ldquo;express consent&rdquo; as required under the
        applicable provincial and federal legislation for:</span
    >
</p>
<ul>
    <li style="font-weight: 400;color:#32302F; font-size:14px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">TrueTenant,</span></li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">TrueTenant Affiliates, and</span></li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">Authorized Service Providers</span></li>
</ul>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >to obtain, verify, and evaluate Personal Information from the sources You authorize, including but not limited
        to:</span
    >
</p>
<ul>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Flinks</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> (banking &amp; transaction-level data)</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">TenCheck</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;"> (credit-related information and tradeline verification)</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Verrif</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> (identity and biometric verification)</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">OpenRoom</strong><span style="font-weight: 400;color:#32302F; font-size:14px;"> (rental-history data)</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <strong style="font-weight:500;font-size:14px;">Landlords and Property Managers</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;"> (rental references and tenancy history)</span>
    </li>
</ul>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You expressly authorize these parties to access, transmit, compare, and process this Personal Information
        solely to generate the </span
    ><strong style="font-weight:500;font-size:14px;">TrueTenant Score</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, prepare tenant-screening reports, verify identity or income, determine Marketplace eligibility, and maintain the
        accuracy of your file.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">If You provide a </span><strong style="font-weight:500;font-size:14px;">Social Insurance Number (SIN)</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">, You understand and agree that TrueTenant may use the SIN </span
    ><strong style="font-weight:500;font-size:14px;">solely to enhance identity matching, prevent fraud, and improve the accuracy of your tenant file</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">, and not for any unrelated purpose.</span>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">By submitting Your order, You acknowledge receipt of the </span
    ><strong style="font-weight:500;font-size:14px;">TrueTenant Privacy Policy</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        and agree that TrueTenant may use and share your Personal Information in accordance with that Policy, which
        forms part of this Agreement and may be amended from time to time as permitted by law.</span
    >
</p>
<ol start="3">
    <li><strong style="font-weight:500;font-size:14px;"> Specific Additional Terms for Tenant Screening Reports and TrueTenant Score Products</strong></li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">This section applies </span><strong style="font-weight:500;font-size:14px;">in addition to Section 1</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        when You, as a landlord, property manager, or authorized representative of a housing provider (&ldquo;Business
        User&rdquo;), order or receive Tenant Screening Reports, the TrueTenant Score, </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">or any CRA-regulated consumer reporting services</span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"> through the Platform (&ldquo;Screening Products&rdquo;).</span>
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">3.1 Use of Screening Products - </strong><span style="font-weight: 400;color:#32302F; font-size:14px;">You agree to:</span></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">(a) Use the Screening Products </span
    ><strong style="font-weight:500;font-size:14px;">only as permitted by, and in compliance with</strong><span style="font-weight: 400;color:#32302F; font-size:14px;">, &nbsp; </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">the Consumer Reporting Act (Ontario), PIPEDA, </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >provincial tenancy legislation, human rights legislation, and all other applicable laws.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">(b) Obtain and maintain </span><strong style="font-weight:500;font-size:14px;">valid, express, written consent</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        from each applicant before requesting a Screening Product, including consent for TrueTenant and its Service
        Providers to collect, verify, and evaluate personal information for tenant-screening purposes.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >(c) Keep all Screening Reports, TrueTenant Scores, identity-verification outputs, and eligibility information </span
    ><strong style="font-weight:500;font-size:14px;">secure and confidential</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, and not disclose any portion of the Screening Products to any third party except:</span
    >
</p>
<ol>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">where disclosure is expressly permitted or required by law,</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">where the applicant has provided explicit written authorization, or</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">where TrueTenant has provided written consent.</span>
    </li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">(d) Abide by all terms and conditions governing your use of Screening Products </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >and comply with all CRA restrictions on use, redisclosure, adverse-action procedures, and record-keeping.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >(e) Not take any action that intentionally harms the reputation, integrity, or legal compliance posture of
        TrueTenant.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >(f) Assume all responsibility and liability for any use, misuse, or unauthorized disclosure of Screening
        Products by You or by any third party that gains access through You&mdash;whether permitted or in violation of
        this Agreement.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">3.2 Security Requirements- </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You shall maintain an information-security program (&ldquo;Program&rdquo;) that includes administrative,
        physical, and technical safeguards (&ldquo;Controls&rdquo;) reasonably designed to:</span
    >
</p>
<ol>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">Ensure the security and confidentiality of Screening Products;</span>
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Protect against anticipated threats or hazards to the integrity of Screening Products;</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Prevent unauthorized access to or use of Screening Products, including the TrueTenant Score, verification
            data, or identity outputs; and</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;"
            >Dispose of Screening Products in a secure manner (e.g., secure deletion, shredding, electronic
            sanitization).</span
        >
    </li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">You acknowledge that Your Program will align with </span
    ><strong style="font-weight:500;font-size:14px;">commercially recognized security frameworks</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >, and that you are solely responsible for compliance with all applicable laws relating to handling consumer
        reporting information.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">3.3</strong> <strong style="font-weight:500;font-size:14px;">Fees, Charges, and Payment Source - </strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >By ordering a Screening Product, You authorize TrueTenant and its Payment Processor (Stripe or other approved
        provider) to charge Your designated payment method (&ldquo;Payment Source&rdquo;). You agree to: (a) Pay for
        each Screening Product in Canadian dollars; (b) Provide and maintain a valid Payment Source; (c) Accept
        responsibility for any bank fees, overdraft charges, or card-issuer penalties triggered by your transaction.
        TrueTenant may update its pricing at any time. Updated pricing will be posted on the Platform and shown to You
        in the order summary prior to submitting a request. Prices exclude HST/GST/QST and any other applicable taxes,
        which will be applied at checkout.</span
    >
</p>
<ol>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">4.3.</span><strong style="font-weight:500;font-size:14px;">All Sales Final - </strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;">Screening Products&mdash;once initiated&mdash;are </span
        ><strong style="font-weight:500;font-size:14px;">final, non-refundable, and non-returnable</strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;"
            >, as each ordered Screening Product triggers immediate processing with third-party verification partners
            and cannot be reversed. TrueTenant has no obligation to refund any payment for a completed Screening
            Product.</span
        >
    </li>
    <li style="font-weight: 400;color:#32302F; font-size:14px;">
        <span style="font-weight: 400;color:#32302F; font-size:14px;">4.4.</span><strong style="font-weight:500;font-size:14px;">Rejection: </strong
        ><span style="font-weight: 400;color:#32302F; font-size:14px;"
            >TrueTenant reserves the right to reject any order for Screening Products for any reason, including but not
            limited to identity-mismatch, fraud risk, unverifiable landlord status, or suspected misuse. You agree that
            TrueTenant shall not be liable to You for any loss or damage arising from the rejection of an order.</span
        >
    </li>
</ol>
<ol start="4">
    <li><strong style="font-weight:500;font-size:14px;"> Specific Terms Applicable to the TrueTenant Business Dashboard</strong></li>
</ol>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">This section applies </span><strong style="font-weight:500;font-size:14px;">in addition to Section 1</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        when You (a landlord, property manager, real estate professional, or other authorized housing provider) access
        or use the TrueTenant Business Dashboard, including any portal located at dashboard.truetenant.ai (the
        &ldquo;Business Dashboard&rdquo;).</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">4.1 Interpretation:</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        The terms and conditions set out in any applicable service agreement executed between You and TrueTenant shall
        continue to govern Your purchase and receipt of tenant-screening services and related offerings. Your
        interactions with TrueTenant through the Business Dashboard are additionally governed by this Agreement and the
        Site Terms of Use that You accepted when creating Your TrueTenant account.</span
    >
</p>
<p style="margin-bottom:15px;">
    <strong style="font-weight:500;font-size:14px;">4.2 SITE TERMS OF USE - Last revised: </strong><strong style="font-weight:500;font-size:14px;">June 24, 2026</strong>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >These Site Terms of Use (&ldquo;Terms&rdquo;) apply to the access and use of the website located at</span
    ><a href="http://www.truetenant.ai"> <span style="font-weight: 400;color:#32302F; font-size:14px;">www.truetenant.ai</span></a
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        (the &ldquo;Site&rdquo;), which is owned and operated by TrueTenant Inc. (&ldquo;TrueTenant&rdquo;). In these
        Terms, TrueTenant is referred to as &ldquo;We,&rdquo; &ldquo;Us,&rdquo; and &ldquo;Our.&rdquo; You, the person
        visiting and using this Site, are referred to as &ldquo;You,&rdquo; &ldquo;Your,&rdquo; or
        &ldquo;Member.&rdquo;</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >When You access the Site to purchase tenant-screening services, the TrueTenant Product Agreement and Terms
        (&ldquo;Agreement&rdquo;) governs Your purchase and use of those services. These Site Terms apply to Your access
        and use of the Site, including all informational pages, product descriptions, and platform interfaces
        (collectively, &ldquo;Content&rdquo;).</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.3 ACCESS TO SITE, USE, AND GOVERNING LAW</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Access to and use of this Site are subject to all laws and regulations applicable in Your province or territory
        of residence. Individuals residing in jurisdictions where the Site or any part thereof is illegal or prohibited
        are not permitted to use the Site. It is Your responsibility to determine whether You may legally use the Site
        and the Services in compliance with all applicable laws. Certain Content may not be available or applicable to
        You based on residency, age, property-management licensing requirements, Ontario&rsquo;s </span
    ><strong style="font-weight:500;font-size:14px;">Consumer Reporting Act (</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">CRA) restrictions, or other eligibility criteria.</span>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >If any provision of these Terms is deemed unlawful, void, or unenforceable, that provision shall be severed and
        will not affect the validity or enforceability of the remaining Terms. The interpretation of Content referenced
        on the Site is governed by the specific agreements between You and TrueTenant, and any applicable laws and
        regulations, including the</span
    >
    <span style="font-weight: 400;color:#32302F; font-size:14px;">CRA for tenant-screening functions.</span>
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">These Terms are made and will be interpreted under </span><strong style="font-weight:500;font-size:14px;">Ontario law</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">, and You submit to the exclusive jurisdiction of the courts located in </span
    ><strong style="font-weight:500;font-size:14px;">Toronto, Ontario</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">. For Quebec residents, these Terms are made and interpreted under </span
    ><strong style="font-weight:500;font-size:14px;">Quebec law</strong><span style="font-weight: 400;color:#32302F; font-size:14px;">.</span>
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.4 NO GUARANTEE OF CONTENT AVAILABILITY</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Because of the nature of the internet and online communications, We do not guarantee uninterrupted or
        error-free operation of the Site or Content. Your own device limitations, browser configuration, network
        provider issues, or excessive system usage may also negatively affect performance.</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >You agree to promptly notify Us of any system error; We will attempt to correct the issue, but You are </span
    ><strong style="font-weight:500;font-size:14px;">not entitled to any refund or compensation</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"> relating solely to Site availability.</span>
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.5 OWNERSHIP</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >All Content on the Site&mdash;including text, images, logos, icons, design elements, selection and arrangement,
        AI-generated assets, and proprietary tenant-screening components (collectively, &ldquo;Site
        Content&rdquo;)&mdash;is protected by Canadian and international copyright, trademark, and intellectual-property
        laws. You may not: alter any proprietary notices, copy, modify, publish, distribute, reverse-engineer, or create
        derivative works of Site Content, scrape, extract, or attempt to reconstruct any TrueTenant models, including
        the TrueTenant Score. TrueTenant retains all intellectual-property rights in the Site and the Services.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.6 SECURITY, COOKIES, AND LINKS</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Once You have accessed the Site, You should log out before leaving Your device unattended. We do not guarantee
        that Site Content or third-party links will be free of malware, viruses, worms, or harmful components. You
        access third-party websites at Your own risk. Links included on our Platform do not constitute endorsements or
        guarantees of external products or services. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >&nbsp;We expressly disclaim any liability of any nature whatsoever arising directly or indirectly from other
        sites connected to the Site by hyperlink. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Information about cookies, pixels, and analytics tools used on the Site is described in our Privacy
        Policy.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.7 LIMITATION OF LIABILITY</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;">All Content on the Site is provided on an </span><strong style="font-weight:500;font-size:14px;">&ldquo;AS IS&rdquo;</strong
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">
        basis without warranties of any kind, express or implied. To the fullest extent permitted by law, TrueTenant
        disclaims all liability arising from Your use of or reliance on Site Content. </span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;"
        >Further, and without limiting the generality of the foregoing, in no event shall We be liable for any direct,
        indirect, incidental, consequential or special damages, losses, claims or expenses arising out of the use of the
        information herein, or in any way connected with Your access to or use of the Site. Without limiting the
        foregoing, We do not represent or warrant that the use of the Site and, including the browsing and downloading
        of any Content or Site Content, will be free of viruses, Trojan horses, worms or other destructive or disruptive
        components. You acknowledge and agree that it is up to You to ensure that you have a complete and current backup
        of the information contained on your computer system prior to using the Site and that You will take reasonable
        precautions to scan for computer viruses, worms, Trojan horses, and other items of a destructive nature when
        using the Site. The Site may contain hyperlinks or other references to third party Internet sites that
        TrueTenant does not own or operate. You may be subject to additional terms and conditions that apply when You
        use third party Internet sites. You agree that You are responsible for reviewing and understanding any terms and
        conditions governing any third-party Internet site and products and TrueTenant has no responsibility
        therefore.&nbsp;</span
    >
</p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >To the extent any liability cannot be excluded, TrueTenant&rsquo;s total aggregate liability arising out of or
        relating to the Services will not exceed the total amount paid by You to TrueTenant for the specific Service
        that gave rise to the claim.</span
    >
</p>
<p style="margin-bottom:15px;"><strong style="font-weight:500;font-size:14px;">4.8 GENERAL</strong></p>
<p style="margin-bottom:15px;">
    <span style="font-weight: 400;color:#32302F; font-size:14px;"
        >These Terms take effect upon Your first access to the Site and apply to all individuals accessing the Site
        through Your device, login, or network credentials. Headings are for convenience only and do not affect
        interpretation. These Terms do not confer rights on any parties other than You, TrueTenant, and any expressly
        named third-party beneficiaries. You may not assign or transfer these Terms. TrueTenant may assign these Terms
        without restriction</span
    ><span style="font-weight: 400;color:#32302F; font-size:14px;">.</span>
</p>

<p style="margin-bottom:5px;margin-top:30px;"><strong style="font-weight:600;font-size:14px;">Contact Information</strong></p>
<p style="margin-bottom:2px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">TrueTenant Inc.</span></p>
<p style="margin-bottom:2px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">713 Indian Road</span></p>
<p style="margin-bottom:2px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">Mississauga, Ontario, L5H1R3, Canada</span></p>
<p style="margin-bottom:2px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">Email: contact@truetenant.ai</span></p>
<p style="margin-bottom:15px;"><span style="font-weight: 400;color:#32302F; font-size:14px;">Online: <a target="_blank" href="https://truetenant.ai" style="color:#2563eb;text-decoration:underline;">truetenant.ai</a></span></p>

`
